import React, { CSSProperties } from "react";

interface LaparGynaeImageProps {
    color?: string;
    style?: CSSProperties;
    svgWidth?: string;
    svgHeight?: string;
}
const LaparGynaeImage: React.FC<LaparGynaeImageProps> = (props: LaparGynaeImageProps) => {
    const {color} = props;
    return (
        <div style={props?.style}>
            <svg viewBox="0 0 128 128" width={props.svgWidth || "32"} height={props.svgHeight || "32"}
                 className="images-icon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px">
                <g>
                    <path fill={color ? color: '#ffffff'} d="M73.79,112.45c-6.56,0-12.85,0-19.92,0c-0.21-3.8-0.47-7.53-0.62-11.27c-0.17-4.14-0.27-8.29-0.35-12.44
                        c-0.13-6.94-0.22-13.88-0.3-20.81c-0.01-1,0.4-2.13,0.05-2.98c-3.81-9.31-6.09-19.87-12.09-27.47C34.84,30.26,24.61,27.5,14.8,27.3
                        c-4.55-0.09-6.08,2.79-4.43,7.13c1.75,4.61,6.47,6.97,11.54,5.79c5.53-1.28,12.24,1.08,14.58,6.16c1.23,2.68,1.8,7.09,0.39,9.18
                        c-1.58,2.33-6.01,4.37-8.71,3.88c-3.71-0.68-7.16-3.6-10.35-6.05c-2.29-1.76-3.69-4.66-5.96-6.45c-5.36-4.21-7.88-9.77-8.66-16.3
                        c-0.88-7.37,3.14-12.17,10.4-10.85c7.95,1.44,15.74,4.07,23.35,6.86c3.98,1.46,6.99,1.66,9.73-1.74
                        c7.07-8.76,27.72-8.61,34.53-0.11c2.92,3.64,6.07,3.25,10.16,1.7c7.12-2.71,14.43-5.23,21.89-6.61c8.65-1.6,12.83,3.37,11.39,12.06
                        c-1.02,6.18-3.71,11.25-8.74,15.18c-2.15,1.68-3.93,3.95-5.49,6.22c-3.71,5.39-10.96,7.96-16.17,5.46c-4-1.92-5.57-6.18-3.9-10.61
                        c2.16-5.73,9.34-9.44,15.6-8.04c5.25,1.17,9.81-1.03,11.64-5.59c1.81-4.51,0.1-7.71-4.68-7.22c-5.04,0.52-10.03,2.12-14.9,3.67
                        c-8.27,2.64-12.75,8.21-16.19,16.6c-4.07,9.93-6.65,19.04-5.69,30.06C77.11,88.96,74.74,100.49,73.79,112.45z"/>
                </g>
            </svg>
        </div>
    );
};

export default LaparGynaeImage;
